var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCollectionFill(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Profiles Fill"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 979"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 978"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 10",
    d: "M6.9913 7.924C9.17945 7.924 10.9533 6.15015 10.9533 3.962C10.9533 1.77385 9.17945 0 6.9913 0C4.80314 0 3.0293 1.77385 3.0293 3.962C3.0293 6.15015 4.80314 7.924 6.9913 7.924Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 981"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 980"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 3175",
    d: "M6.991 9.14453C5.13687 9.14453 3.35868 9.88107 2.04762 11.1921C0.736548 12.5032 0 14.2814 0 16.1355C0 16.6299 0.196384 17.104 0.545952 17.4536C0.89552 17.8032 1.36963 17.9995 1.864 17.9995H12.118C12.6124 17.9995 13.0865 17.8032 13.436 17.4536C13.7856 17.104 13.982 16.6299 13.982 16.1355C13.982 14.2814 13.2455 12.5032 11.9344 11.1921C10.6233 9.88107 8.84513 9.14453 6.991 9.14453Z",
    fill: "white"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollectionFill);
export default __webpack_public_path__ + "static/media/collectionFill.9ba1e0aab97cb3792c10faf1df5cf0a9.svg";
export { ForwardRef as ReactComponent };